import React from 'react';
import { connect } from 'react-redux';
import { JSONSchemaFieldPropType } from 'common/json-schema-form/prop-types';
import { selectGroupCurrency } from '../../selectors';
import { EntityFormField } from 'common/json-schema-form/fields';
import { DEPENDENT_CLASS_OPTIONS } from '../enrollment-config.constants';
import { AmountByFieldWrapper } from './amount-by-field-wrapper.view';
import { MONEY_REF } from 'common/json-schema-form/json-schema-form.constants';

export const AmountByDependentClassPresenter = ({
  name,
  propSchema,
  groupCurrency,
  ...props
}) => {
  const itemProperties = propSchema?.items?.properties ?? {};
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading -- FIXME: automatically added for existing issue
    <AmountByFieldWrapper {...props} {...propSchema} name={name}>
      {({ idx }) => (
        <>
          <EntityFormField
            name={`${name}.${idx}.name`}
            propSchema={itemProperties.name}
          />
          <EntityFormField
            name={`${name}.${idx}.dependent_class`}
            propSchema={{
              enum: DEPENDENT_CLASS_OPTIONS,
              ...itemProperties.dependent_class,
            }}
          />
          <EntityFormField
            name={`${name}.${idx}.amount`}
            groupCurrency={groupCurrency}
            propSchema={{
              ...itemProperties.amount,
              $ref: MONEY_REF,
            }}
          />
        </>
      )}
    </AmountByFieldWrapper>
  );
};

AmountByDependentClassPresenter.propTypes = JSONSchemaFieldPropType;

export const AmountByDependentClass = connect(state => ({
  groupCurrency: selectGroupCurrency(state),
}))(AmountByDependentClassPresenter);
